import { lazy } from 'react';

const LazyWhitelistIpManagementView = lazy(() => import('./whitelist-ip-management-view'));
export default LazyWhitelistIpManagementView;
